<script>
import terms from "@/terms"
import { findComponents } from "@/support"
import { useAuth } from "@/composables/useAuth"

export default {
  components: {
    ...findComponents(require.context("@", true, /\.vue$/)),
  },
  setup() {
    const { user } = useAuth()

    return { terms, user, window }
  },
}
</script>
